export const CODE_OF_CONDUCT_HEADING_TITLE = [
  "CODE OF CONDUCT",
  "Code of Conduct",
  "Code of Conduct and Compliance",
];

export const QUESTION_TO_ANSWER_HEADING_TITLE = [
  "Question To Answer",
  "Responses to Specific Questions",
];

export const EXPECTATION_SETTINGS_HEADING_TITLE = [
  "Expectation setting, service standards, qualifications and suitability",
];

// Preamble sections that should be auto-inserted into the editor when
// the uploaded template doesn't already have them. Unlike CoC (which has
// state-specific content from the template's jurisdiction choices),
// these three carry no pre-defined content — we insert just the heading
// + an empty paragraph for the expert to type into. Heading text variants
// reflect what we've seen across the template seeds + uploaded docs.
export const CONFLICT_OF_INTEREST_HEADING_TITLE = [
  "CONFLICT OF INTEREST",
  "Conflict of Interest",
];

export const OTHER_ATTENDEES_HEADING_TITLE = [
  "ANY OTHER ATTENDEES",
  "Any Other Attendees",
  "Interpreter and/or Other Attendees",
  "Interpreter and Other Attendees",
  "OTHER ATTENDEES",
  "Other Attendees",
];

export const UNUSUAL_CIRCUMSTANCES_HEADING_TITLE = [
  "UNUSUAL CIRCUMSTANCES",
  "Unusual Circumstances",
];

// Module-name variants for the List-of-Documents-Provided section.
// Matched against the template module list to identify which orderedModule
// row carries the doc-sorter document schedule + the expert's commentary
// (handled by editor/documents-table-insert.ts — MDRS-98). Variants reflect
// what the backend's `LIST_OF_DOCUMENTS_MODULE_NAME` constant emits.
export const LIST_OF_DOCUMENTS_HEADING_TITLE = [
  "List of Documents",
  "List of Documents Provided",
];

// Modules that the docx editor auto-inserts on draft load (the three
// remaining preamble sections above + the LOI-derived Question To Answer
// block). These must NOT appear in the Report Builder section list or in the
// Assessment Prep / Scribe snippet-mapping dialog — the user can't author
// them through the modules panel, they materialise in the document directly.
//
// MDRS-139: Code of Conduct is deliberately NOT listed here. CoC is now an
// authorable module — it appears in the section list and is mapped/edited
// through the modules panel like any normal section, so it must not be
// filtered out as auto-inserted.
//
// Matching mirrors module-insert.ts's headingMatches(): lowercased,
// punctuation- and numbering-stripped, with substring containment either
// way so template-shipped variants still resolve to the canonical section.
const AUTO_INSERTED_MODULE_VARIANTS: readonly string[] = [
  ...CONFLICT_OF_INTEREST_HEADING_TITLE,
  ...OTHER_ATTENDEES_HEADING_TITLE,
  ...UNUSUAL_CIRCUMSTANCES_HEADING_TITLE,
  ...QUESTION_TO_ANSWER_HEADING_TITLE,
  ...LIST_OF_DOCUMENTS_HEADING_TITLE,
];

/** Lowercase, strip leading numbering + punctuation, collapse whitespace.
 *  Shared with `isCodeOfConductSection` so "is authorable" and "activates the
 *  CoC panel" recognise the same heading variants. */
export const normaliseModuleName = (s: string): string =>
  s
    .toLowerCase()
    .replace(/^\s*\d+[.)]\s*/, "")
    .replace(/[^a-z0-9\s]+/g, " ")
    .replace(/\s+/g, " ")
    .trim();

const NORMALISED_AUTO_INSERTED_VARIANTS = AUTO_INSERTED_MODULE_VARIANTS.map(
  normaliseModuleName
).filter((v) => v.length > 0);

export const isAutoInsertedModule = (moduleName: string): boolean => {
  const n = normaliseModuleName(moduleName);
  if (!n) return false;
  return NORMALISED_AUTO_INSERTED_VARIANTS.some(
    (v) => n === v || n.includes(v) || v.includes(n)
  );
};
